// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var GET_DOCUMENT_BY_NAME = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query GetDocumentByName($name: String!, $tenantId: uuid!) {\n        sequent_backend_document(where: {_and: {name: {_eq: $name}, tenant_id: {_eq: $tenantId}}}) {\n            id\n        }\n    }\n"], ["\n    query GetDocumentByName($name: String!, $tenantId: uuid!) {\n        sequent_backend_document(where: {_and: {name: {_eq: $name}, tenant_id: {_eq: $tenantId}}}) {\n            id\n        }\n    }\n"])));
var templateObject_1;
